import { cloneDeep } from 'lodash'

import { Services } from '@sigma-frontend-libs/commons'
import { PAYMENTS_STATUSES } from '@sigma-legacy-libs/essentials/lib/constants'

import { PAYMENTS_FILTER, dateFilter, permissionPresets } from '@/utils'

import render from './render'

export default {
  name: 'PaymentsFilter',

  mixins: [ dateFilter ],

  computed: {
    canGetUsersAsResellerUp() {
      return this.checkPermissions(`advanced.${Services.users}.get`, permissionPresets.resellerUp)
    },

    statusItems() {
      return PAYMENTS_STATUSES.map(status => {
        return {
          title: this.getTranslate(`${Services.payments}.statuses.${status}`),
          value: status
        }
      })
    }
  },

  methods: {
    getDefaultFilter() {
      return cloneDeep(PAYMENTS_FILTER)
    },

    clearFilter() {
      this.proxy = cloneDeep(this._inputFilter(this.getDefaultFilter()))
    }
  },

  render
}
